
    import { defineComponent } from 'vue';
    import { Map, Marker } from 'mapbox-gl';
     class dcmapboxcoord{
        public latitude: number = 0;
        public longitude: number = 0;

    };
    export default defineComponent({
        data() {
            return {
                map: null as Map|null,
                marker: null as Marker|null
            };
        },
        props: {
            mapbox_accesstoken: String,
            latitude: Number,
            longitude:Number
        },
        methods: {
            InitMapBox() {
                var self = this;
                let latitude: number = 0;
                let longitude: number = 0;
                if (this.latitude != null && this.longitude != null) {
                     latitude = this.latitude;
                    longitude = this.latitude;
                   
                }
               
                      
                         this.map = new Map({
                            accessToken: this.mapbox_accesstoken,
                            container: 'dcmapbox', // container ID
                            style: 'mapbox://styles/mapbox/streets-v11', // style URL
                            center: [longitude,latitude], // starting position [lng, lat]
                            zoom: 9 // starting zoom
                         });
                if (this.map != null)
                    this.marker = new Marker()
                        .setLngLat([longitude,latitude])
                        .addTo(this.map);
                this.map.on('click', (e:any) => {
                            let coord = new dcmapboxcoord();
                            coord.latitude = e.lngLat.lat;
                            coord.longitude = e.lngLat.lng;
                            if (this.marker!=null)
                                this.marker.remove();
                                if (self.map!=null)
                                    self.marker = new Marker()
                                        .setLngLat([coord.longitude, coord.latitude])
                                    .addTo(self.map);
                            self.$emit("setcoord", coord);

                        })
            }
        },
        computed: {
            combined() {
                return this.latitude +'_'+this.longitude;
            }
        },
        watch: {
            combined: function (newVal: string, oldVal: string) {
                let values = newVal.split("_");
                let latitude = +values[0];
                let longitude = +values[1];
                if (this.map != null) {
                    this.map.setCenter([longitude, latitude]);
                    if (this.marker != null)
                        this.marker.remove();
                    if (this.map != null)
                        this.marker = new Marker()
                            .setLngLat([longitude, latitude])
                            .addTo(this.map);
                }
            }
        },
        mounted() {
            this.InitMapBox();
        }
    });
